import { Properties } from "csstype";
import { TranslationKey } from "../../components/ApplicationProvider";
import {
    CompanyAccessOption,
    CustomerInfo,
    DetailedLicenseData,
    ResellerInfo,
} from "../../graphql";
import { CompanyFormInput } from "../../graphql/Mutations/Companies";
import { IScreenProps } from "../Screen";
import { match as routerMatch } from "react-router-dom";
import { DocumentNode } from "graphql";
import { PureQueryOptions } from "@apollo/client";

/** FIXME GC-71488: Share max length const in server/src/services/companies.ts */
export const COMPANY_NAME_MAX_LENGTH = 100;
interface DataFormField {
    required?: boolean;
    // Returns a localized string
    invalidator?: (string: any) => string | undefined;
    inputComponent?: string;
    labelKey?: TranslationKey;
    infoTextKey?: TranslationKey;
    labelDefault: string;
    type?: string;
    placeholder?: string;
    render?: (any: any) => string;
    parse?: (input: string) => any;
    disabled?: () => boolean;
    style?: Properties<string | number>;
}

export interface CompanyDataFormField extends DataFormField {
    id: keyof CompanyFormInput;
}

export interface CustomerDataFormField extends DataFormField {
    id: keyof CustomerInfo;
}

export interface ResellerDataFormField extends DataFormField {
    id: keyof ResellerInfo;
}

export interface IEditCompanyProps extends IScreenProps {
    match: routerMatch<{ companyId?: string }>;
}

export interface ICompanyFormProps extends IScreenProps {
    match: routerMatch<{ companyId?: string }>;
    mutation: DocumentNode; //TODO GC-91587 To see if this can be handled in a better way(earlier the type annotation used to be any)
    companyInput?: CompanyFormInput;
    refetch?: any;
    refetchQueries?: (string | PureQueryOptions)[];
    editing?: boolean;
    readOnly?: boolean;
    licenses?: DetailedLicenseData[];
    accessOptions?: CompanyAccessOption[];
}
